<template>
  <div>
    <router-view/>
  </div>
</template>
<script>
/* ============
 * Entry Point
 * ============
 *
 * The entry point of the application.
 */

export default {
  /**
   * The name of the application.
   */
  name: 'Navigator7',

  /**
   * Fires when the app has been mounted.
   */
  mounted() {
    // If the user is authenticated,
    // fetch the data from the API
    if (this.$store.state.auth.authenticated) {
      this.$store.dispatch('account/find');
    }
  },
};
</script>

<style lang="scss">
:root {
  --sidebar-height: 64px;
  --spacer: 2rem;
  --main-bg-color: coral;
  --color-status-a: 0, 136, 0;
  --color-status-b: 248, 213, 28;
  --color-status-c: 191, 83, 83;
  --color-status-d: 221, 211, 213;
  --fill-opacity: .2;
  --hover-fill-opacity: .6;
  --stroke-opacity: .85;
  --hover-stroke-opacity: .85;
  --primary-color: #577189;
  --horizontal-dividing-line: 1px solid #ccc;
  --header-box-shadow: var(--v-toolbar-box-shadow, 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%));
}

.theme--light.v-application {
  background: var(--v-application-background, #fafafa) !important;
  color: var(--v-application-color, rgba(0, 0, 0, 0.87)) !important;
}

.v-application .turquoise {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}

.v-application .turquoise--text {
  color: var(--primary-color) !important;
  caret-color: var(--primary-color) !important;
}

.theme--light.v-data-table {
  thead tr:last-child th {
    border-bottom: var(--v-data-table-border-bottom, 1px solid rgba(0, 0, 0, 0.12)) !important;
  }

  tbody tr:not(:last-child) {
    border-bottom: var(--v-data-table-border-bottom, 1px solid rgba(0, 0, 0, 0.12)) !important;
  }
}

.v-divider--vertical {
  border-width: var(--v-divider-vertical-border-width, 0 thin 0 0) !important;
}

.v-text-field {
  &.v-input--is-focused {
    > .v-input__control {
      > .v-input__slot {
        &:after {
          border-width: var(--horizontal-input-underline, thin 0 0 0) !important;
        }
      }
    }
  }

  > .v-input__control {
    > .v-input__slot {
      &:before {
        border-width: var(--horizontal-input-underline, thin 0 0 0) !important;
      }

      &:before, &:after {
        transition: var(--input-slot-unterline-transition, '0.3s cubic-bezier(0.25, 0.8, 0.5, 1)') !important;
      }
    }
  }
}

.v-data-table td {
  font-size: 0.875em !important;
}

.v-input {
  font-size: 1em !important;
}

.v-label {
  font-size: 1em !important;
}

.v-messages {
  font-size: 0.75em !important;
}

.v-toolbar {
  box-shadow: var(--header-box-shadow);
}

.v-card {
  box-shadow: var(--v-card-box-shadow, 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)) !important;
}

.theme--light.v-data-table {
  color: var(--v-data-table-color, rgba(0, 0, 0, 0.87)) !important;
}

</style>
